import React, { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import {cartContext}from'../Contexts/CartContext';
import Loading from '../Loading/Loading';
import notify from '../Utilities/Notify';
import Swal from 'sweetalert2';
import axios from 'axios';
import BaseURL from '../Utilities/BaseUrl';
import { useNavigate,Link } from 'react-router-dom';
import CartNotFound from '../CartNotFound/CartNotFound';
import { Helmet } from 'react-helmet';
export default function Cart() {
  
let navigate=useNavigate();
let {getCart,productsCart,totalPrice,updateCountInCart,loading,disable,check,setcheck}=useContext(cartContext);

function setCount(id,count) {
  updateCountInCart(id,count)
}
  function remove(productID) {
 Swal.fire({
  title:'Warning ...!',
  html:`Are You Sure That you want remove this item <i class="fa-regular fa-face-surprise text-warning fa-1x"></i>`,
  icon:'warning',
  showCancelButton:true,
  showConfirmButton:true,
  confirmButtonText:'confirm',
 

 }).then((result)=>{

  if(result.isConfirmed)
  { 
    axios.delete(`${BaseURL}cart/${productID}`,{headers:{token:localStorage.getItem('token')}}).then((data)=>{
       setcheck(false);
      getCart();
    
    }).catch((error)=>{console.log(error);
      });
  }
 })
  
}
  useEffect(() => {
    
   
 setcheck(false)
     getCart()
   
    
    
  
  }, [])
  
   
  return <><Helmet>
  <title>cart</title>
  
</Helmet>
  { productsCart.length!=0 ? <div className="container pt-3 cartContainer " style={{backgroundColor:'#F0F3F2'}}>
      <div className="row">
      <h3 className='text-black mb-1'>Shop Cart</h3>
      <h5 className='text-main mb-2'>Total Cart Price {totalPrice} </h5>

        {productsCart.map((item,index)=>{return <div className="col-sm-12" key={index}>
          <div className="cartContains mb-2 ">
            <div className="leftSide">
           
            <div className="myProd d-flex  p-3" >
              <img src={item.product.imageCover} alt="imageCover" style={{width:80,height:70}} className='me-4'/>
              <div className="orderDesc  p-3">
              <p className='h6 fs-6'>{item.product.title.split(' ').slice(0,2).join(' ')}</p>
              <p className='h6'> <span className='text-main '>Price: </span>{item.price}</p>
              <p className='text-danger cursor-pointer' onClick={()=>{remove(item.product._id)}}>Remove <i className="fa-regular fa-trash-can text-danger"></i></p>
              </div>
            </div>
            </div>
            <div className="rightSide d-flex">
              <button type='button ' className='btn btn-success'disabled={loading&&disable} onClick={()=>{setCount(item.product._id,item.count+1)}}><span className='fs-4 text-main'>+</span></button>
              <p className='h6 pt-2 me-2 ms-2 text-center'> <span className='text-main '>Count: </span>{ item.count < 0?0:item.count}</p>
              <button type='button ms-2 ' className='btn btn-success'disabled={loading&&disable} onClick={()=>{setCount(item.product._id,item.count-1)}}><span className='fs-4 text-main'>-</span></button>
            </div>
          </div>
        </div>})}
        <div className="footer text-center mt-5 pb-5">
         <Link to={'/PaymentCash'}><button className='btn bg-main text-white '>Pay Cash</button></Link> 
         <Link to={'/PaymentCredit'}> <button className='btn bg-main text-white '>Pay Credit</button></Link> 
        </div>
       
      </div>
     
     </div>:localStorage.getItem('cartNum')!=0 && localStorage.getItem('cartNum')!=null ?<Loading/>:<CartNotFound/>
      
     }
  </>
}
